import { Injectable, inject } from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, concatMap, filter, withLatestFrom} from 'rxjs/operators';
import {addDescription, saveDescriptionSynchronizedClones} from './description.actions';
import {DescriptionsDbService} from '../services/descriptions-db.service';

import {select, Store} from '@ngrx/store';
import {selectActiveCourse, selectAllCourses, selectAllLessons, selectDescriptionsState} from './selectors';
import {AppState} from './index';
import {throwError} from 'rxjs';
import {DescriptionActions} from './action-types';
import {MessagesService} from '../shared/services/messages.service';
import {LoadingService} from '../shared/services/loading.service';
import {environment} from "../../environments/environment";


@Injectable()
export class DescriptionEffects {
  private actions$ = inject(Actions);
  private store = inject<Store<AppState>>(Store);
  private loading = inject(LoadingService);
  private descriptionsDB = inject(DescriptionsDbService);
  private messages = inject(MessagesService);


  loadDescriptionIfNeeded$ = createEffect(() => this.actions$
    .pipe(
      ofType(DescriptionActions.loadDescription),
      withLatestFrom(this.store.pipe(select(selectDescriptionsState))),
      filter(([action, descriptions]) => !(action.descriptionId in descriptions)),
      concatMap(
        ([action]) => this.loading.showLoader(this.descriptionsDB.loadDescription(action.descriptionId)),
        ([action], description) => addDescription({id: action.descriptionId, description})
      ),
      catchError(err => {
        this.messages.error('Could not load description.');
        return throwError(err);
      })
    ));




  saveDescription$ = createEffect(() => this.actions$
    .pipe(
      ofType(DescriptionActions.saveDescription),
      withLatestFrom(
        this.store.pipe(select(selectAllLessons)),
        this.store.pipe(select(selectAllCourses)),
      ),
      concatMap(([action, lessons, courses]) => {

        const obs$ = this.descriptionsDB.saveDescription(action.id, action.description);

        if(environment?.features?.cloneCourse /*&& activeCourse?.cloneType === "synchronized"*/) {

          this.store.dispatch(saveDescriptionSynchronizedClones({description: action, lessons, courses}))

        }

        return obs$;

      }),
      catchError(err => {
        this.messages.error('Could not save description.');
        return throwError(err);
      })
    ),
    {dispatch:false});

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);


  constructor() {

  }


}
